(function () {
  const categoryTeesPage = function () {
    const roundPickerChange = function () {
      const $select = $("#category_tees_round_type_id");
      const baseUrl = $select.data("url");
      const roundTypeId = $select.val();
      if (!baseUrl || !roundTypeId) return;

      $(".generic-loader").removeClass("d-none");
      window.location.href = `${baseUrl}?round_type_id=${roundTypeId}`;
    };

    $(document).on("change", "#category_tees_round_type_id", roundPickerChange);

    $(document).on("turbolinks:load", function () {
      if (!$("body").hasClass("controller-leagues-players-category-tees")) return;

      $(".generic-loader").addClass("d-none");
    });
  };

  if (typeof window !== "undefined") {
    window.categoryTeesPage = categoryTeesPage;
  }

  return categoryTeesPage();
})();
